import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CONSENT_API_ROUTES } from './config/api.const';
import {
  ConsentStatusResponse,
  ConsentSubmitResponse,
} from './interfaces/consent.interface';

@Injectable({
  providedIn: 'root',
})
export class ConsentDataClient {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.apiConfig.baseUrlBackend;

  public getConsentStatus() {
    return this.httpClient.get<ConsentStatusResponse>(
      `${this.baseUrl}/${CONSENT_API_ROUTES.CONSENT}`,
    );
  }

  public submitConsent() {
    return this.httpClient.post<ConsentSubmitResponse>(
      `${this.baseUrl}/${CONSENT_API_ROUTES.CONSENT}`,
      { timestamp: new Date().toISOString() },
      { observe: 'response' },
    );
  }
}
